import {
  closestCenter,
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  rectSortingStrategy,
  SortableContext,
} from "@dnd-kit/sortable";
import React from "react";
import SortableItem from "./SortingItem";
import classes from "./SortingArea.module.scss";
import { backgroundColorDnd } from "../../../../commons/colors";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../states/userState";

const SortingArea = ({ drawingList, setDrawingList }) => {
  const user = useRecoilValue(userState);
  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { distance: 5 } })
  );
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return; // If you drag off the list, 'over' can be null

    // If the item has moved somewhere else, reorder the list
    if (active.id !== over.id) {
      setDrawingList((prevItems) => {
        // Find the old/new indexes by matching 'id'
        const oldIndex = prevItems.findIndex((item) => item.id === active.id);
        const newIndex = prevItems.findIndex((item) => item.id === over.id);
        return arrayMove(prevItems, oldIndex, newIndex);
      });
    }
  };

  return (
    <div
      className={classes.root}
      style={backgroundColorDnd(user?.mode ?? "lite")}
    >
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        {/* SortableContext uses verticalListSortingStrategy for a vertical list */}
        <SortableContext items={drawingList} strategy={rectSortingStrategy}>
          {drawingList.map((item) => (
            <SortableItem key={item.id} item={item} />
          ))}
        </SortableContext>
      </DndContext>
    </div>
  );
};

export default SortingArea;
